export default {
	namespaced: true,
	state: {
		alertas: []
	},

	getters: {
		actual (state) {
			if (state.alertas.length === 0) {
				return null
			}

			return state.alertas[0]
		}
	},

	mutations: {
		nueva (state, payload) {
			if (!Array.isArray(payload.buttons)) {
				payload.buttons = []
			}

			if (payload.buttons.length === 0) {
				payload.buttons.push({
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: null
				})
			}
			state.alertas.push(payload)
		},
		alert (state, payload) {
			if (!Array.isArray(payload.buttons)) {
				payload.buttons = []
			}

			if (payload.buttons.length === 0) {
				payload.buttons.push({
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: null
				})
			}
			payload.claseCabecera = ''
			payload.tipo = 'alerta'
			state.alertas.push(payload)
		},
		error (state, payload) {
			if (!Array.isArray(payload.buttons)) {
				payload.buttons = []
			}

			if (payload.buttons.length === 0) {
				payload.buttons.push({
					titulo: 'Aceptar',
					clase: 'btn btn-sm btn-primary',
					icono: 'fa fa-check',
					valor: null
				})
			}
			payload.claseCabecera = 'bg-danger text-white'
			payload.tipo = 'error'
			state.alertas.push(payload)
		},
		confirm (state, payload) {
			if (!Array.isArray(payload.buttons) || payload.buttons.length === 0) {
				payload.buttons = [
					{
						titulo: 'Aceptar',
						clase: 'btn btn-sm btn-primary',
						icono: 'fa fa-check',
						valor: true
					},
					{
						titulo: 'Cancelar',
						clase: 'btn btn-sm btn-danger',
						icono: 'fa fa-ban',
						valor: false
					}
				]
			}

			state.alertas.push(payload)
		},
		cerrar (state) {
			state.alertas.splice(0, 1)
		}
	}
}



// WEBPACK FOOTER //
// ./src/modulos/core/vue/store/alertas.js